import { Node } from '@tiptap/core'
import { mergeAttributes } from '@tiptap/core'

import { EmptyObject } from '~shared/core/primitives'
import { NodeAttributes } from '~shared/richtext/richtext.types'

export const MENTIONSNODE_NAME = 'rsMentionNode' as const
export const MENTIONSNODE_TAG = 'rs-mention' as const

/** @deprecated We're migrating from `<custom-mention/>` to `<rs-mention/>` */
export const MENTIONSNODE_TAG_LEGACY = 'custom-mention' as const

type MentionNodeOptions = EmptyObject

export type MentionNodeAttributes = {
  mentionId: string
  fallbackName: string
}

export const MentionNode = Node.create<MentionNodeOptions, MentionNodeAttributes>({
  name: MENTIONSNODE_NAME,
  group: 'inline',
  atom: true,
  inline: true,
  selectable: false,
  defining: true,

  addAttributes() {
    return {
      mentionId: {
        parseHTML: (element) => element.getAttribute('data-mention-id'),
        renderHTML: (attributes) => {
          if (!attributes.mentionId) return {}

          return { 'data-mention-id': attributes.mentionId }
        },
      },
      // Fallback name to use after the mention was deleted
      fallbackName: {
        parseHTML: (element) => element.getAttribute('data-fallback-name'),
        renderHTML: (attributes) => {
          if (!attributes.fallbackName) return {}

          return { 'data-fallback-name': attributes.fallbackName }
        },
      },
    } satisfies NodeAttributes<MentionNodeAttributes>
  },

  parseHTML() {
    return [
      { tag: MENTIONSNODE_TAG },
      { tag: MENTIONSNODE_TAG_LEGACY }, // Parse legacy tag during migration period
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      MENTIONSNODE_TAG,
      mergeAttributes(HTMLAttributes),
      '', // Add empty child to force a closing tag
    ]
  },

  renderText({ node }) {
    // const attrs = node.attrs as MentionNodeAttributes
    // const mention = getMentionFromCache(attrs.mentionId)
    // const currentName = mention?.name
    // const fallbackName = attrs.fallbackName ?? 'unknown'
    // return `@${currentName ?? fallbackName}`
    return node.text ?? '' // TODO: Implement safely
  },
})
